﻿import React from 'react';
import { Box, IconButton, Tooltip } from '@mui/material';
import {
  ArrowUpward as ArrowUpwardIcon,
  ArrowDownward as ArrowDownwardIcon,
  SwapVert as SwapVertIcon,
} from '@mui/icons-material';
import { dataFormStyles } from '~/modules/covenants/CovenantsDataForm/styles.ts';
import { SortDirection } from '~/modules/covenants/types.ts';

const SORT_ICONS: Record<SortDirection, React.ReactNode> = {
  asc: <ArrowUpwardIcon fontSize="small" />,
  desc: <ArrowDownwardIcon fontSize="small" />,
  none: <SwapVertIcon fontSize="small" />,
};

const SORT_TOOLTIPS: Record<SortDirection, string> = {
  none: 'Сортувати за датою',
  asc: 'Від найновіших',
  desc: 'Скинути сортування',
};

interface ISortableHeaderProps {
  label: string;
  direction: SortDirection;
  onToggle: () => void;
}

export const SortableHeader: React.FC<ISortableHeaderProps> = ({ label, direction, onToggle }) => (
  <Box sx={dataFormStyles.headerInline}>
    {label}
    <Tooltip title={SORT_TOOLTIPS[direction]}>
      <IconButton
        size="small"
        onClick={onToggle}
        sx={dataFormStyles.headerControlButton(direction !== SortDirection.None)}
      >
        {SORT_ICONS[direction]}
      </IconButton>
    </Tooltip>
  </Box>
);
